import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React from 'react';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

const AuthorizationIdFlowRequestTable = () => 
        <Table aria-label="customized table" style={{ width: 710 }}>
        <TableHead sx={{ width: 710 }}>
          <TableRow>
            <StyledTableCell style={{fontSize:16, width: 60}}>Parameter</StyledTableCell>
            <StyledTableCell style={{fontSize:16, width: 650}}>Explanation</StyledTableCell>
          </TableRow>
          </TableHead>
          <TableBody> 
            <StyledTableRow key={"grant_type"}>
              <StyledTableCell>grant_type</StyledTableCell>
              <StyledTableCell>authorization_id</StyledTableCell>
            </StyledTableRow>
            <StyledTableRow key={"authorization_id"}>
              <StyledTableCell>authorization_id</StyledTableCell>
              <StyledTableCell>Customer id </StyledTableCell>
            </StyledTableRow>
            <StyledTableRow key={"scope"}>
              <StyledTableCell>scope</StyledTableCell>
              <StyledTableCell>Authorized scope of Access Token</StyledTableCell>
            </StyledTableRow>
            <StyledTableRow key={"sign"}>
              <StyledTableCell>sign (in Header)</StyledTableCell>
              <StyledTableCell>Signed ("base64 encoded string"(client_id:client_secret))</StyledTableCell>
            </StyledTableRow>
            <StyledTableRow key={"Authorization "}>
              <StyledTableCell>Authorization (in Header)</StyledTableCell>
              <StyledTableCell>Basic "base64 encoded string"(clientid:clientsecret)</StyledTableCell>
            </StyledTableRow>
          </TableBody>
        </Table>;

export default AuthorizationIdFlowRequestTable;
